import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Error 404. The requested resource could not be found", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_ctx.isLoading(_ctx.data))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["w-2 mx-auto", _ctx.showLoadingSpinner ? 'py-36' : 'py-40'])
      }, [
        (_ctx.showLoadingSpinner)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : _createCommentVNode("", true)
      ], 2))
    : (_ctx.isLoaded(_ctx.data))
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : (_ctx.notFound(_ctx.data))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true)
}